function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Landing-Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Desktop-A-01",
  transform: "translate(-797.000000, -337.000000)"
}, React.createElement("g", {
  id: "BOX-LOCKUP",
  transform: "translate(797.000000, 337.000000)"
}, React.createElement("g", {
  id: "Group-4"
}, React.createElement("polygon", {
  id: "Fill-1",
  fill: "#DB0007",
  points: "22.4717727 84.6173415 0.00246969697 170.956427 20.5898636 403.495573 302.184712 403.495573 322.777045 170.956427 300.302803 84.6173415"
}), React.createElement("path", {
  d: "M266.566742,236.525433 L278.954742,242.195433 L284.931409,229.136652 L250.85453,213.549091 L244.882803,226.602933 L255.354318,231.393787 C245.0705,268.22903 206.903803,295.581348 161.387288,295.581348 C115.870773,295.581348 77.7040758,268.22903 67.4202576,231.393787 L77.8967121,226.602933 L71.9200455,213.549091 L37.8481061,229.136652 L43.8198333,242.195433 L56.2127727,236.525433 C71.1544394,285.619335 112.600894,320.923482 161.387288,320.923482 C210.178621,320.923482 251.625076,285.619335 266.566742,236.525433",
  id: "Path",
  fill: "#FFBC0D"
}), React.createElement("path", {
  d: "M253.971288,84.6207988 C249.022015,50.3390305 240.788045,29.3086646 227.461561,29.3086646 C213.542348,29.3086646 204.616864,50.4723841 199.193409,84.6207988 L123.586106,84.6207988 C118.157712,50.4723841 109.232227,29.3086646 95.3179545,29.3086646 C81.9865303,29.3086646 73.7525606,50.3390305 68.8032879,84.6207988 L22.4717727,84.6207988 C43.9433182,25.4117744 73.4512576,0.000493902439 97.530803,0.000493902439 C121.076894,0.000493902439 145.284864,25.1500061 161.387288,56.4189695 C177.494652,25.1500061 201.697682,0.000493902439 225.243773,0.000493902439 C249.323318,0.000493902439 278.831258,25.4117744 300.307742,84.6207988 L253.971288,84.6207988 Z",
  id: "Path",
  fill: "#FFBC0D"
})))));

var SvgHappyMealBox = function SvgHappyMealBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 323 404",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHappyMealBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happy-meal-box.3580c0e1.svg";
export { ForwardRef as ReactComponent };